export type TBaseEntity = {
  id: number;
  name: string;
};

export type TListResponse<T> = {
  count: number;
  results: T[];
  next: string | null;
  previous: string | null;
};

export type TSortDirection = 'asc' | 'desc';

export enum EApproveStatus {
  UPDATED = 'updated',
  ACTUAL = 'actual',
  EXPECTATION = 'expectation',
}

export enum EMemberRole {
  PROJECT_MANAGER = 11, // "Руководитель проекта"
  CHIEF_PROJECT_ENGINEER = 14, // "Главный инженер проекта"
  CHIEF_PTO_SPECIALIST = 46, // "Главный специалист ПТО"
  LEAD_PTO_ENGINEER = 47, // "Ведущий инженер ПТО"
  PTO_ENGINEER = 48, // "Инженер ПТО"
  ARCHITECTURAL_SUPERVISION = 201, // "Авторский надзор"
  CHIEF_PROJECT_ENGINEER_PI = 202, // "ГИП ПИ"
}
